export default {"src":"/frontend-static/_next/static/media/lightweight-hoodie.969db9c6.svg","height":210,"width":203,"blurWidth":0,"blurHeight":0};